import { useEffect, useState } from "react";
import { message } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import {
  GET_DATA_EMS,
  GET_LOAD_IMAGE_NEW_ALL,
  GET_STATUS_THAIPOST,
  HEADERS_EXPORT,
  HEADERS_EXPORT_BEN,
  HEADERS_EXPORT_DETAIL,
  HEADERS_UPIMAGE,
  POST_APPROVED_DUE,
  POST_BILL_PAYMENT,
  POST_CONTNO_DETAIL_SEARCH,
  POST_FOLLOW_CUSTOMER,
  POST_INSERT_NOTE_NEW,
  POST_JUDGE_BEEYPUP,
  POST_LOAD_DATA_DUEPAYMENT,
  POST_LOAD_DATA_DUEPAYMENT_JUDGE,
  POST_LOAD_MEMO_NEW,
  POST_LOAD_REJUDGE,
  POST_LOAN_DB2,
  POST_PREVIEW_BEEYPUP,
  POST_PREVIEW_JUDGE,
  POST_UPDATE_MEMO,
} from "../../../API/apiUrls";
import { useSearch } from "../hook/SearchContext";
import TokenCheck from "../../../../hook/TokenCheck";
import { exportCardDebtorPdf } from "../export/CardDebtor";
import {
  getAllowedTypes,
  getMenuTypesToLoad,
  collapseBlankLines,
} from "./utils";
import {
  USER_IDS,
  ROLE_IDS,
  HIA_APPROVED_STATUSES,
  JUDGMENT_REVIEWED_THRESHOLD,
  MESSAGES,
} from "./constants";

const useContractDetailData = () => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const roleId = parseInt(localStorage.getItem("ROLE_ID"));
  const token = localStorage.getItem("TOKEN");
  const [signOut] = TokenCheck();

  const [loadingJudge, setLoadingJudge] = useState(false); // loading สำหรับ judgeData
  const [loadingLoan, setLoadingLoan] = useState(false); // loading สำหรับ loanData
  const [loadingImge, setLoadingImge] = useState(false); // loading สำหรับ loanData
  const [loanData, setLoanData] = useState(null);
  const [judgeData, setJudgeData] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [memoDataOld, setMemoDataOld] = useState(null);
  const [memoDataNew, setMemoDataNew] = useState([]);
  const [showNoteOld, setShowNoteOld] = useState(true);
  const [showNoteNew, setShowNoteNew] = useState(true);
  const [editMemoOld, setEditMemoOld] = useState(true);
  const [remarkValueOld, setRemarkValueOld] = useState(null);
  const [remarkValueNew, setRemarkValueNew] = useState(null);
  const [billPayment, setBillPayment] = useState(null);
  const [duePaymentData, setDuePaymentData] = useState([]);
  const [beeypupData, setBeeypupData] = useState([]);
  const [followCusData, setFollowCusData] = useState([]);
  const [expenseListData, setExpenseListData] = useState([]);
  const { searchData, clearSearch } = useSearch();
  const [isModalpayIn, setIsModalPayIn] = useState(false);

  const [fileListByContractCourt, setFileListByContractCourt] = useState([]);
  const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");
  const [isModalAddImge, setIsModalAddImge] = useState(false);
  const [isModalPreviewPayment, setIsModalPreviewPayment] = useState(false);
  const [isModalBillAfterCourtOldData, setIsModalBillAfterCourtOldData] =
    useState(false);
  const [statusEms, setStatusEms] = useState([]);
  const [mailData, setMailData] = useState(null); // ✅ เพิ่ม state
  const [loadBeeypup, setLoadBeeypup] = useState(false);
  const [loadApprovDue, setLoadApprovDue] = useState(false);
  const [rejudgeData, setRejudgeData] = useState(null);

  useEffect(() => {
    console.log("searchData", searchData);

    setFileListByContractCourt([]);
    setLoanData(null);
    setJudgeData(null);
    setRejudgeData(null);
    setMemoDataOld(null);
    setExpenseListData([]);
    setMemoDataNew([]);
    setDuePaymentData([]);
    setBeeypupData([]);
    setFollowCusData([]);
    setActiveTab("1");
    setRemarkValueOld(null);
    setRemarkValueNew(null);
    if (searchData?.CONTNO) {
      // setLoanData(null);
      loadJudgeData(searchData);
      // loadLoanData(searchData?.CONTNO);
      // loadMemoDataOld(searchData?.CONTNO);
    }
  }, [searchData]);

  useEffect(() => {
    console.log(judgeData);

    setFileListByContractCourt([]);
    setLoanData(null);
    setJudgeData(null);
    setRejudgeData(null);
    setMemoDataOld(null);
    setExpenseListData([]);
    setMemoDataNew([]);
    setDuePaymentData([]);
    setBeeypupData([]);
    setFollowCusData([]);
    setActiveTab("1");
  }, []);

  const loadLoanData = async (contno) => {
    const useContno = /^V\d/.test(contno) ? contno.substring(1) : contno;
    setLoadingLoan(true);
    try {
      const res = await axios.post(
        POST_LOAN_DB2,
        { CONTNO: `'${useContno}'` },
        { headers: HEADERS_EXPORT_BEN },
      );
      const data = res?.data?.[0] || null;
      if (data) setLoanData(data);
      return data;
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("Error loadLoanData:", error);
        message.error("เกิดข้อผิดพลาดในการโหลดข้อมูลสัญญา");
      }
      return null;
    } finally {
      setLoadingLoan(false);
    }
  };

  // helpers — pure functions, test ง่าย
  const getJudgeValidationMessage = ({
    data,
    userId,
    roleId,
    currentStatus,
  }) => {
    if (data?.details === "ไม่พบข้อมูล") return MESSAGES.NO_DATA;

    if (
      userId === USER_IDS.HIA &&
      !HIA_APPROVED_STATUSES.includes(data?.judge?.[0]?.currentStatus)
    ) {
      return MESSAGES.HIA_NOT_APPROVED;
    }

    const judgeStatus = data?.judge?.[0]?.currentStatus;
    if (
      userId !== USER_IDS.HIA &&
      roleId === ROLE_IDS.JUDGE_REVIEWER &&
      judgeStatus !== undefined &&
      judgeStatus <= JUDGMENT_REVIEWED_THRESHOLD
    ) {
      return MESSAGES.JUDGMENT_NOT_REVIEWED;
    }

    return null;
  };

  const loadJudgeData = async (payload) => {
    setLoadingJudge(true);
    console.log("payload", payload);

    try {
      const { data } = await axios.post(POST_CONTNO_DETAIL_SEARCH, payload, {
        headers: HEADERS_EXPORT_DETAIL,
      });

      if (!data) return;

      // 1) แสดง validation message (ถ้ามี)
      const validationMsg = getJudgeValidationMessage({
        data,
        userId,
        roleId,
      });
      if (validationMsg) message.info(validationMsg);

      // 2) อัปเดต state หลัก
      setJudgeData(data);
      setExpenseListData(data.work_expense_list ?? []);

      // 3) จัดการ memo
      setMemoDataNew(data.note ?? []);

      // 4) โหลดข้อมูล rejudge (ไม่ block การแสดงผลหลัก)
      if (data.rejudge_from_id_judge) {
        loadRejudge(data.rejudge_from_id_judge);
      } else {
        setRejudgeData(null);
      }
    } catch (error) {
      handleLoadJudgeError(error);
    } finally {
      setLoadingJudge(false);
    }
  };

  const handleLoadJudgeError = (error) => {
    if (error?.name === "CanceledError") return;

    if (error?.response?.status === 401) {
      signOut();
      return;
    }

    console.error("Error loadJudgeData:", error);
    message.error(MESSAGES.LOAD_ERROR);
  };

  const loadMemoDataOld = async (contno) => {
    const useContno = /^V\d/.test(contno) ? contno.substring(1) : contno;
    setLoadingLoan(true);
    try {
      const res = await axios.post(POST_LOAD_MEMO_NEW, {
        contractNo: useContno,
      });
      if (res?.data) {
        const memo1 = collapseBlankLines(res.data.MEMO1);
        setMemoDataOld({ ...res.data, MEMO1: memo1 });
        setRemarkValueOld(memo1);
      }
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("Error loadMemoDataOld:", error);
        message.error("เกิดข้อผิดพลาดในการโหลดข้อมูลสัญญา");
      }
    } finally {
      setLoadingLoan(false);
    }
  };

  const loadBillPayment = async () => {
    setLoadingLoan(true);
    try {
      const res = await axios.post(
        POST_BILL_PAYMENT,
        {
          CONTNO: searchData.CONTNO,
        },
        { headers: HEADERS_EXPORT_BEN },
      );
      if (res?.data) {
        setBillPayment(res?.data);
        setIsModalPayIn(true);
      }
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("Error loadMemoDataOld:", error);
        message.error("เกิดข้อผิดพลาดในการโหลดข้อมูลสัญญา");
      }
    } finally {
      setLoadingLoan(false);
    }
  };

  const loadDuepayment = async (api, payload) => {
    if (duePaymentData?.length > 0) return;

    setLoadingLoan(true);
    try {
      const res = await axios.post(api, payload, {
        headers: HEADERS_EXPORT_BEN,
      });
      if (res?.data) {
        console.log(res);
        setDuePaymentData(res.data.data);
      }
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("Error loadMemoDataOld:", error);
        message.error("เกิดข้อผิดพลาดในการโหลดข้อมูลสัญญา");
      }
    } finally {
      setLoadingLoan(false);
    }
  };

  const loadFollowCustomer = async () => {
    if (followCusData?.length > 0) return;

    setLoadingLoan(true);
    try {
      const res = await axios.post(
        POST_FOLLOW_CUSTOMER,
        {
          idJudge: judgeData?.judge?.[0]?.idJudge,
        },
        { headers: HEADERS_EXPORT_BEN },
      );
      if (res?.data) {
        console.log(res);
        setFollowCusData(res.data.data);
      }
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("Error loadMemoDataOld:", error);
        message.error("เกิดข้อผิดพลาดในการโหลดข้อมูลสัญญา");
      }
    } finally {
      setLoadingLoan(false);
    }
  };

  const loadImge = async (force = false) => {
    // ✅ skip ถ้าไม่ได้ force และมีข้อมูลอยู่แล้ว
    if (!force && fileListByContractCourt.length > 0) return;

    setLoadingImge(true);

    try {
      let loanId;
      if (judgeData?.judge?.length === 0 || !judgeData?.judge) {
        loanId = judgeData?.loanId;
      } else {
        loanId = judgeData?.judge?.[0]?.loanId;
      }
      const menuTypes = getMenuTypesToLoad(judgeData);
      const allowed = getAllowedTypes(judgeData);

      if (!loanId || menuTypes.length === 0) {
        message.warning("ไม่มีเงื่อนไขโหลดเอกสาร");
        setFileListByContractCourt([]);
        return;
      }

      const responses = await Promise.all(
        menuTypes.map((menuType) =>
          axios.get(`${GET_LOAD_IMAGE_NEW_ALL}/${menuType}/${loanId}`, {
            headers: HEADERS_UPIMAGE,
          }),
        ),
      );

      const mapImg = (img) => ({
        ...img,
        CONTNO: judgeData?.judge?.[0]?.CONTNO,
        loanId: judgeData?.judge?.[0]?.loanId,
        lawsuitId: judgeData?.judge?.[0]?.lawsuitId,
      });

      const allImages = responses
        .flatMap((res) => (res.data || []).map(mapImg))
        .filter((img) =>
          allowed.some(
            (a) => a.menuType === img.menuType && a.imageType === img.imageType,
          ),
        );

      if (allImages.length === 0) message.warning("ไม่พบเอกสาร");

      setFileListByContractCourt(allImages);
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`เกิดข้อผิดพลาด: ${error.message}`);
      setFileListByContractCourt([]);
    } finally {
      setLoadingImge(false);
    }
  };

  const postMemoNew = async () => {
    if (!remarkValueNew) {
      message.warning("กรุณากรอกหมายเหตุก่อนบันทึก");
      return;
    }
    const payload = {
      lawsuitId: judgeData.lawsuitId
        ? judgeData.lawsuitId
        : judgeData.judge?.[0]?.lawsuitId,
      note: remarkValueNew,
      userId: userId,
    };
    setLoadingLoan(true);
    try {
      const res = await axios.post(POST_INSERT_NOTE_NEW, payload, {
        headers: HEADERS_EXPORT_BEN,
      });
      if (res?.status === 200) {
        message.success("บันทึกหมายเหตุสำเร็จ");
        setRemarkValueNew("");
        await loadJudgeData(searchData); // ✅ reload note list
      }
      return res;
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("Error postMemoNew:", error);
        message.error("เกิดข้อผิดพลาดในการบันทึกหมายเหตุ");
      }
    } finally {
      setLoadingLoan(false);
    }
  };

  const postMemoOld = async () => {
    const payload = {
      DATA_TYPE: memoDataOld.DATA_TYPE,
      CONTNO: memoDataOld.CONTNO,
      MEMO1: memoDataOld.MEMO1,
    };

    setLoadingJudge(true);
    try {
      const res = await axios.post(POST_UPDATE_MEMO, payload, {
        headers: HEADERS_EXPORT_BEN,
      });
      if (res?.status === 200) {
        message.success("บันทึกหมายเหตุสำเร็จ");
        setEditMemoOld(true);
        await loadMemoDataOld(memoDataOld.CONTNO);
      }
      return res?.data;
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message;
      if (status === 404) message.error("ไม่พบปลายทาง (404)");
      else if (status === 400) message.error(`ข้อมูลไม่ถูกต้อง: ${serverMsg}`);
      else if (status === 500)
        message.error("เกิดข้อผิดพลาดจาก Server ! จำนวนตัวอักษรเยอะเกินไป");
      else
        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`,
        );
      console.error("postMemoOld error:", error);
    } finally {
      setLoadingJudge(false);
    }
  };

  const loadDataBeeypup = async (api, payload) => {
    if (beeypupData?.length > 0) return;

    setLoadBeeypup(true);

    try {
      const res = await axios.post(api, payload, {
        headers: HEADERS_EXPORT_BEN,
      });
      if (res.status === 200) {
        setBeeypupData(
          Array.isArray(res.data) ? res.data : res.data?.data || [],
        );
      }
    } catch (err) {
      message.error(
        err?.response?.status === 404 ? "ไม่พบข้อมูล" : "เกิดข้อผิดพลาด",
      );
    } finally {
      setLoadBeeypup(false);
    }
  };

  const postApporve = async (payload) => {
    setLoadApprovDue(true);
    try {
      const res = await axios.post(POST_APPROVED_DUE, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      const { status, data } = res;

      if (status === 200) {
        console.log("✅ API Response:", data);
        return data;
      }
    } catch (error) {
      const status = error?.response?.status;
      const errData = error?.response?.data;
      const serverMsg = errData?.error || errData?.message || error.message;

      if (status === 404) {
        message.error("ไม่พบปลายทาง (404)");
      } else if (status === 400) {
        message.error(serverMsg);
      } else if (status === 500) {
        message.error("เกิดข้อผิดพลาดจากเซิร์ฟเวอร์ (500)");
      } else {
        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`,
        );
      }
      console.error("❌ postDocStatus error:", error);
      throw error;
    }
  };

  // แยก error handler ใช้ซ้ำได้หลายที่
  const handleApiError = (error, ctx = "getEmsData") => {
    const status = error?.response?.status;
    const serverMsg =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message;
    if (status === 404) message.error("ไม่พบปลายทาง (404)");
    else if (status === 400) message.error(`ข้อมูลไม่ถูกต้อง: ${serverMsg}`);
    else if (status === 500)
      message.error("เกิดข้อผิดพลาดจาก Server ! จำนวนตัวอักษรเยอะเกินไป");
    else
      message.error(
        `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`,
      );
    console.error(`${ctx} error:`, error);
  };

  const getEmsData = async () => {
    const contno = (searchData?.CONTNO ?? "").trim().replace(/^V/i, "");

    setLoadingJudge(true);
    try {
      // ยิงพร้อมกัน — อิสระต่อกัน ไม่ต้องรอทีละตัว
      const [statusRes, emsRes] = await Promise.allSettled([
        axios.get(GET_STATUS_THAIPOST, { headers: HEADERS_EXPORT_BEN }),
        contno
          ? axios.get(`${GET_DATA_EMS}${encodeURIComponent(contno)}`, {
              headers: HEADERS_EXPORT_BEN,
            })
          : Promise.resolve(null),
      ]);

      // 1) สถานะ EMS (master)
      if (statusRes.status === "fulfilled") {
        if (statusRes.value?.status === 200) setStatusEms(statusRes.value.data);
      } else {
        handleApiError(statusRes.reason, "GET_STATUS_THAIPOST");
      }

      // 2) ข้อมูล EMS ตามสัญญา
      if (emsRes.status === "fulfilled") {
        if (emsRes.value?.status === 200) setMailData(emsRes.value.data);
      } else {
        handleApiError(emsRes.reason, "GET_DATA_EMS");
      }

      return statusRes.status === "fulfilled" ? statusRes.value?.data : null;
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoadingJudge(false);
    }
  };

  const loadRejudge = async (rejudgeFromIdJudge) => {
    if (!rejudgeFromIdJudge) return;
    const payload = { rejudge_from_id_judge: rejudgeFromIdJudge };
    try {
      const { status, data } = await axios.post(POST_LOAD_REJUDGE, payload, {
        headers: HEADERS_EXPORT_DETAIL,
      });

      if (status === 200) setRejudgeData(data);
    } catch (error) {
      setRejudgeData(null);
      if (error?.response?.status === 401) {
        signOut();
        return;
      }
      const status = error?.response?.status;
      const errData = error?.response?.data;
      const serverMsg = errData?.error || errData?.message || error.message;

      if (status === 404) {
        message.error("ไม่พบปลายทาง (404)");
      } else if (status === 400) {
        message.error(serverMsg);
      } else if (status === 500) {
        message.error("เกิดข้อผิดพลาดจากเซิร์ฟเวอร์ (500)");
      } else {
        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`,
        );
      }
      console.error("❌ loadRejudge error:", error);
    }
  };

  // ── Tab change handler ────────────────────────────────────────────────────
  const handleTabChange = (key) => {
    setActiveTab(key);
    if ((key === "6" || key === "7") && searchData?.CONTNO && !loanData) {
      console.log("judgeData?.judge?.[0]?.CONTNO", judgeData);

      if (judgeData?.judge?.[0]?.CONTNO) {
        loadLoanData(judgeData?.judge[0]?.CONTNO);
      } else {
        loadLoanData(searchData.CONTNO);
      }
    }

    if (key === "8") {
      if (judgeData?.judge?.[0]?.idJudge) {
        loadFollowCustomer();
      }

      if (judgeData?.judge?.[0]?.CONTNO && !remarkValueOld) {
        loadMemoDataOld(judgeData?.judge?.[0]?.CONTNO);
      } else {
        if (!remarkValueOld) {
          loadMemoDataOld(searchData.CONTNO);
        }
      }
    }

    if (key === "4") {
      let apiUseDue;
      let payloadDue;
      let apiUseBeeypup;
      let payloadBeeypup;
      console.log("duePaymentData", duePaymentData);
      console.log("beeypupData", beeypupData);

      if (judgeData?.loanNew !== null || !duePaymentData || !beeypupData) {
        console.log("judgeData?.loanNew");

        apiUseDue = POST_LOAD_DATA_DUEPAYMENT;
        payloadDue = {
          loanNewId: judgeData?.loanNew?.LoanNewId,
        };
        apiUseBeeypup = POST_PREVIEW_BEEYPUP;
        payloadBeeypup = {
          NEW_CONTNO: judgeData?.loanNew?.NEWCONTNO,
          loanNewId: judgeData?.loanNew?.LoanNewId,
          DATETIME: dayjs().format("YYYY-MM-DDTHH:mm:ssZ"),
        };

        loadDuepayment(apiUseDue, payloadDue);
        loadDataBeeypup(apiUseBeeypup, payloadBeeypup);
      } else if (
        judgeData?.loanJudge !== null ||
        !duePaymentData ||
        !beeypupData
      ) {
        console.log("judgeData?.loanJudge");

        apiUseDue = POST_LOAD_DATA_DUEPAYMENT_JUDGE;
        payloadDue = {
          loanJudgeId: judgeData?.loanJudge?.loanJudgeId,
        };

        apiUseBeeypup = POST_JUDGE_BEEYPUP;
        payloadBeeypup = {
          NEW_CONTNO: judgeData?.loanJudge?.NEW_CONTNO,
          loanJudgeId: judgeData?.loanJudge?.loanJudgeId,
          DATETIME: dayjs().format("YYYY-MM-DDTHH:mm:ssZ"),
        };

        loadDuepayment(apiUseDue, payloadDue);
        loadDataBeeypup(apiUseBeeypup, payloadBeeypup);
      }
    }

    if (key === "2") {
      if (judgeData?.judge?.[0]?.CONTNO) {
        loadLoanData(judgeData?.judge[0]?.CONTNO);
        let apiUseBeeypup;
        let payloadBeeypup;

        if (judgeData?.judge?.[0]?.CONTNO && !remarkValueOld) {
          loadMemoDataOld(judgeData?.judge?.[0]?.CONTNO);
        }
        if (judgeData?.flagLoanNew === 1 || !beeypupData) {
          console.log("333");
          console.log("judgeData?.loanNew----->");
          apiUseBeeypup = POST_PREVIEW_BEEYPUP;
          payloadBeeypup = {
            NEW_CONTNO: judgeData?.loanNew?.NEWCONTNO,
            loanNewId: judgeData?.loanNew?.LoanNewId,
            DATETIME: dayjs().format("YYYY-MM-DDTHH:mm:ssZ"),
          };
          loadDataBeeypup(apiUseBeeypup, payloadBeeypup);
          console.log(
            "judgeData?.judge?.[0]?.CONTNO",
            judgeData?.judge?.[0]?.CONTNO,
          );
          console.log("remarkValueOld", remarkValueOld);
        } else if (
          (judgeData?.flagLoanNew === 2 && judgeData?.loanJudge) ||
          !beeypupData
        ) {
          console.log("666");
          console.log("judgeData?.loanJudge----->");
          apiUseBeeypup = POST_JUDGE_BEEYPUP;
          payloadBeeypup = {
            NEW_CONTNO: judgeData?.loanJudge?.NEW_CONTNO,
            loanJudgeId: judgeData?.loanJudge?.loanJudgeId,
            DATETIME: dayjs().format("YYYY-MM-DDTHH:mm:ssZ"),
          };
          loadDataBeeypup(apiUseBeeypup, payloadBeeypup);
          console.log(
            "judgeData?.judge?.[0]?.CONTNO",
            judgeData?.judge?.[0]?.CONTNO,
          );
          console.log("remarkValueOld", remarkValueOld);
        }
      }
    }

    if (key === "9") {
      loadImge();
    }

    if (key === "10") {
      loadFollowCustomer();
    }

    if (key === "13") {
      getEmsData();
    }
  };

  useEffect(() => {
    return () => clearSearch();
  }, []);

  const handleBillRequest = async () => {
    let newContno;
    let code_contno;

    if (judgeData?.judge?.length > 0) {
      newContno = judgeData.judge[0].newContno;
      code_contno = newContno?.replace(/^[A-Za-z]/, "86").replace(/-/g, "");
    } else {
      newContno = searchData.CONTNO;
    }

    console.log("judgeData?.judge[0]?.CONTNO", judgeData);

    let freshLoanData;

    if (!loanData) {
      freshLoanData = await loadLoanData(newContno);
    } else {
      freshLoanData = loanData;
    }

    if (
      !judgeData ||
      judgeData?.details === "ไม่พบข้อมูล" ||
      !judgeData?.loanNew
    ) {
      console.log("newContno", newContno);
      console.log("1.ไม่พบข้อมูล");

      const initialData = {
        company: {
          label: "บริษัท วัน มันนี่ จำกัด (สำนักงานใหญ่)",
          value: "one_money",
          address:
            "89 หมู่ 14 ถ.มิตรภาพ ต.ในเมือง อ.เมืองขอนแก่น จ.ขอนแก่น 40000",
          tel: "043-239-888",
          license: "T0406-000",
        },
        pay: [
          {
            CONTNO:
              judgeData?.judge?.length > 0
                ? judgeData.judge[0].CONTNO
                : freshLoanData?.LOAN?.CONTNO, // ใช้ freshLoanData แทน loanData (state)
            newContno: newContno,
            judgement: "0",
            judgementLack: "0",
            judgementInterest: "0",
            interestRate: "0",
            lackOfBenefits: "0",
            interestRateOfLack: "0",
            trackingFee: "0",
            attorneyFees: "0",
            fee: "0",
            flagLoanNew: 1,
            TOT_UPAY: freshLoanData?.LOAN?.TOT_UPAY?.toString(),
            T_NOPAY: freshLoanData?.LOAN?.T_NOPAY?.toString(),
            NCSHPRC: freshLoanData?.LOAN?.NCSHPRC?.toString(),
            CODE_CONTNO:
              judgeData?.judge?.length > 0
                ? code_contno
                : freshLoanData?.LOAN?.CONTNO,
            CUSTOMER_ID: null,
            CUSCOD: freshLoanData?.CUSTOMER?.CUSCOD,
            ref: judgeData?.judge?.length > 0 ? "001" : "006",
            SNAM: freshLoanData?.CUSTOMER?.SNAM,
            NAME1: freshLoanData?.CUSTOMER?.NAME1,
            NAME2: freshLoanData?.CUSTOMER?.NAME2,
            addressTr: freshLoanData?.CUSTOMER?.ADDRESS || null,
          },
        ],
      };

      console.log("initialData", initialData);
      setBillPayment(initialData);
      setLoanData(freshLoanData); // sync state ด้วย
    } else {
      console.log("2.พบข้อมูล");
      loadBillPayment();
    }

    setIsModalPayIn(true);
  };

  const handleReload = () => {
    setFileListByContractCourt([]);
    loadImge(true);
  };

  // ใช้ร่วมกันในหลายแท็บ (ข้อมูลสัญญาใหม่ / ข้อมูลสัญญาใหม่(พิพากษา) / ตารางดิว)
  // options: { showNotes, pdf, openWindow } ส่งต่อให้ exportCardDebtorPdf
  const exportCardDebtor = async (options = {}) => {
    const isJudgeRecord = !judgeData?.loanNew;
    const loanNew = judgeData?.loanNew
      ? judgeData?.loanNew
      : judgeData?.judge?.[0];
    if (!loanNew) {
      return message.warning("ไม่มีข้อมูลสัญญา(ใหม่)");
    }
    try {
      let freshLoanData = loanData;
      if (!freshLoanData) {
        const contnoForLoan =
          loanNew?.ISSUNO ||
          judgeData?.judge?.[0]?.CONTNO ||
          searchData?.CONTNO;
        freshLoanData = await loadLoanData(contnoForLoan);
      }

      return await exportCardDebtorPdf({
        loanNew,
        customer: freshLoanData?.CUSTOMER,
        guarantors: freshLoanData?.GUARANTORS,
        mortgage: freshLoanData?.MORTGAGE,
        isJudgeRecord,
        chqtran: judgeData?.chqtran,
        chqtranArothr: judgeData?.chqtran_arothr,
        flagLoanNew: judgeData?.flagLoanNew,
        beeypupData: beeypupData,
        remarkValueOld: remarkValueOld,
        judgeData: judgeData,
        ...options,
      });
    } catch (error) {
      console.error("handlePrintCardDebtor error:", error);
      message.error("เกิดข้อผิดพลาดในการสร้างเอกสาร");
    }
  };

  const handlePrintCardDebtor = () => exportCardDebtor();

  return {
    // auth / identity
    userId,
    roleId,
    token,
    signOut,
    // search context
    searchData,
    // state
    loadingJudge,
    loadingLoan,
    loadingImge,
    loanData,
    setLoanData,
    judgeData,
    activeTab,
    memoDataOld,
    setMemoDataOld,
    memoDataNew,
    showNoteOld,
    setShowNoteOld,
    showNoteNew,
    setShowNoteNew,
    editMemoOld,
    setEditMemoOld,
    remarkValueOld,
    setRemarkValueOld,
    remarkValueNew,
    setRemarkValueNew,
    billPayment,
    duePaymentData,
    beeypupData,
    followCusData,
    expenseListData,
    isModalpayIn,
    setIsModalPayIn,
    fileListByContractCourt,
    setFileListByContractCourt,
    pdfPreviewOpen,
    setPdfPreviewOpen,
    pdfPreviewUrl,
    setPdfPreviewUrl,
    isModalAddImge,
    setIsModalAddImge,
    isModalPreviewPayment,
    setIsModalPreviewPayment,
    isModalBillAfterCourtOldData,
    setIsModalBillAfterCourtOldData,
    statusEms,
    mailData,
    loadBeeypup,
    loadApprovDue,
    setLoadApprovDue,
    // loaders / handlers
    loadLoanData,
    loadJudgeData,
    loadMemoDataOld,
    loadBillPayment,
    loadDuepayment,
    loadFollowCustomer,
    loadImge,
    postMemoNew,
    postMemoOld,
    loadDataBeeypup,
    postApporve,
    getEmsData,
    handleTabChange,
    handleBillRequest,
    handleReload,
    handlePrintCardDebtor,
    exportCardDebtor,
    rejudgeData,
  };
};

export default useContractDetailData;
